import { addWeeks as addWeeksFns } from 'date-fns';

export default function addWeeks(date: Date, weeks: number): Date {
  return addWeeksFns(date, weeks);
}
